import { useColorScheme } from '@mui/joy';

export const useFinalColorScheme = (): 'light' | 'dark' => {
  const { mode, systemMode } = useColorScheme();
  return mode === 'system' || !mode ? (systemMode ?? 'light') : mode;
};
